export default{
    data() {
        return {
            missionStatusMap:{
                'UN_LOCK':'-',
                'LOCK':'已定稿',
                'ALREADY_PRINT':'已送印',
                'COMPLETED':'已完成',
                'RECALL':'已撤回',
                'CHECKED':'已检查',
            },
            statusOptions: [
                { name: "待检查", value: "UN_LOCK" },
                { name: "已检查", value: "CHECKED" },
                { name: "已定稿", value: "LOCK" },
                { name: "已送印", value: "ALREADY_PRINT" },
                { name: "已完成", value: "COMPLETED" },
                { name: "已撤回", value: "RECALL" },
               
            ],
        }
    },
    methods: {
        missionStatusFormatter(row){
            return this.missionStatusMap[row.status]||'-'
        },
        payTypeFormatter(row){
            return !row.pay_type || row.pay_type==0?'通用支付':row.pay_type==1?'仅线下支付':'仅线上支付'
        }
    },
}


// WEBPACK FOOTER //
// ./src/views/book/mission-status-mixin.js